export const hasAnyPropChanged = <T extends Record<string, any>>(object: T, base: T): boolean =>
  JSON.stringify(object) !== JSON.stringify(base)
